import * as React from 'react';

export interface RouteObject {
  path: string;
  exact?: boolean;
  name?: string;
  component: any;
}

// below routes will be render with AdminLayout
export const staffRoutes: RouteObject[] = [
  { path: '/router/orders', exact: true, name: 'Order Assignment', component: React.lazy(() => import('./App/pages/OrderAssignmentPage')) },
  {
    path: '/router/orders/assign',
    exact: true,
    name: 'Assignment to User',
    component: React.lazy(() => import('./App/pages/AssignToUserPage')),
  },

  // edit order-edit

  {
    path: '/customer-service/orders',
    exact: true,
    name: 'Customer Orders',
    component: React.lazy(() => import('./App/pages/CustomerServiceOrders')),
  },
  {
    path: '/customer-service/order/1',
    exact: true,
    name: 'Customer Orders',
    // component: React.lazy(() => import('./App/pages/OrderDetail')),
    component: React.lazy(() => import('./App/pages/CustomerService/OrderForm/OrderForm')),
  },
  {
    path: '/customer-service/order/2',
    exact: true,
    name: 'Customer Orders',
    component: React.lazy(() => import('./App/pages/CustomerServiceOrderForm2')),
  },
  {
    path: '/customer-service/warehouse-orders',
    exact: true,
    name: 'Warehouse Orders',
    component: React.lazy(() => import('./App/pages/CustomerServiceWarehouseOrders')),
  },
  {
    path: '/customer-service/warehouse-order',
    exact: true,
    name: 'Warehouse Order',
    component: React.lazy(() => import('./App/pages/CreateNewWarehouseOrderPage')),
  },

  { path: '/warehouse/orders', exact: true, name: 'Orders', component: React.lazy(() => import('./App/pages/WarehouseOrderPage')) },
  {
    path: '/warehouse/record',
    exact: true,
    name: 'Order Record',
    component: React.lazy(() => import('./App/pages/WarehouseOrderRecordPage')),
  },

  {
    path: '/operator/airline-pricing',
    exact: true,
    name: 'Airline Pricing',
    component: React.lazy(() => import('./App/pages/OperationAirlinePricingPage')),
  },
  {
    path: '/operator/customer-management',
    exact: true,
    name: 'Customer Management',
    component: React.lazy(() => import('./App/pages/CustomerManagementPage')),
  },
  {
    path: '/operator/warehouse-orders',
    exact: true,
    name: 'Warehouse Orders',
    component: React.lazy(() => import('./App/pages/OperationWarehouseOrdersPage')),
  },
  {
    path: '/operator/warehouse-order',
    exact: true,
    name: 'Warehouse Order',
    component: React.lazy(() => import('./App/pages/CreateNewWarehouseOrderPage')),
  },
  {
    path: '/operator/orders',
    exact: true,
    name: 'Customer Orders',
    component: React.lazy(() => import('./App/pages/OperationCustomerOrdersPage')),
  },
  {
    path: '/operator/order/1',
    exact: true,
    name: 'Customer Orders',
    component: React.lazy(() => import('./App/pages/CustomerService/OrderForm/OrderForm')),
  },
  {
    path: '/operator/order/2',
    exact: true,
    name: 'Customer Orders',
    component: React.lazy(() => import('./App/pages/CustomerServiceOrderForm2')),
  },
  {
    path: '/operator/customer-info',
    exact: true,
    name: 'Customer Info',
    component: React.lazy(() => import('./App/pages/OperationCustomerManagementPage')),
  },
  {
    path: '/operator/address-management',
    exact: true,
    name: 'Address Management',
    component: React.lazy(() => import('./App/pages/AddressManagementPage')),
  },

  {
    path: '/bushiness-manager/airline-pricing',
    exact: true,
    name: 'Business Status',
    component: React.lazy(() => import('./App/pages/BusinessManagerBusinessStatusPage')),
  },
  {
    path: '/bushiness-manager/customer-management',
    exact: true,
    name: 'Staff Role Assignment',
    component: React.lazy(() => import('./App/pages/BusinessManagerStaffRoleAssignmentPage')),
  },

  {
    path: '/accounting/dashboard',
    exact: true,
    name: 'Dashboard',
    component: React.lazy(() => import('./App/pages/AccountingDashboard')),
  },
  {
    path: '/accounting/debit-note',
    exact: true,
    name: 'Debit Note',
    component: React.lazy(() => import('./App/pages/AccountingDebitNote')),
  },
  {
    path: '/accounting/debit-note/create',
    exact: true,
    name: 'Create Debit Note',
    component: React.lazy(() => import('./App/pages/AccountingCreateDebitNote')),
  },
  {
    path: '/accounting/credit-note',
    exact: true,
    name: 'Credit Note',
    component: React.lazy(() => import('./App/pages/AccountingCreditNote')),
  },
  {
    path: '/accounting/credit-note/create',
    exact: true,
    name: 'Create Credit Note',
    component: React.lazy(() => import('./App/pages/AccountingCreateCreditNote')),
  },
  {
    path: '/accounting/credit-note/insert',
    exact: true,
    name: 'Insert Credit Note',
    component: React.lazy(() => import('./App/pages/AccountingInsertCreditNote')),
  },
  {
    path: '/accounting/costing',
    exact: true,
    name: 'Costing',
    component: React.lazy(() => import('./App/pages/AccountingCosting')),
  },
  {
    path: '/accounting/costing/create',
    exact: true,
    name: 'Create Costing',
    component: React.lazy(() => import('./App/pages/AccountingCreateInvoice')),
  },
  {
    path: '/accounting/statement',
    exact: true,
    name: 'Statement',
    component: React.lazy(() => import('./App/pages/AccountingStatement')),
  },
  {
    path: '/accounting/statement/create',
    exact: true,
    name: 'Create Costing',
    component: React.lazy(() => import('./App/pages/AccountingCreateStatement')),
  },
  // {
  //   path: '/accounting/send-statement',
  //   exact: true,
  //   name: 'Send Statement',
  //   component: React.lazy(() => import('./App/pages/AccountingSendStatement')),
  // },
];

// below routes will be render with AdminLayout
export const customerRoutes: RouteObject[] = [
  // { path: '/customer-sample', exact: true, name: 'Sample Page', component: React.lazy(() => import('./Demo/Other/SamplePage')) },
  {
    path: '/dashboard',
    exact: true,
    name: 'Dashboard',
    component: React.lazy(() => import('./App/pages/CustomerDashboardPage')),
  },
  { path: '/orders', exact: true, name: 'Orders', component: React.lazy(() => import('./App/pages/CustomerOrdersPage')) },
  { path: '/check-rates', exact: true, name: 'Check Rates', component: React.lazy(() => import('./App/pages/CheckRatesPage')) },
  { path: '/pre-order/1', exact: true, name: 'Pre Order', component: React.lazy(() => import('./App/pages/PreOrderPage_1')) },
  { path: '/pre-order/2', exact: true, name: 'Pre Order', component: React.lazy(() => import('./App/pages/PreOrderPage_2')) },
  {
    path: '/pre-order/double-check',
    exact: true,
    name: 'Pre Order',
    component: React.lazy(() => import('./App/pages/PreOrderPage_DoubleCheck')),
  },
  { path: '/pre-order/finished', exact: true, name: 'Pre Order', component: React.lazy(() => import('./App/pages/PreOrderPage_Finished')) },
];

export const publicRoutes: RouteObject[] = [
  { path: '/', exact: true, name: 'Signin', component: React.lazy(() => import('./App/pages/SignIn')) },
];
// export default routes;
